import type { Account } from "@/api/types";
import { documentLineAccounts } from "./accountPickers";

/**
 * The accounts a sale can be credited to (ADR-0046): income first, then liabilities that no role names,
 * which is where deferred revenue sits. Like every document line, never a required account (control, tax,
 * exchange or rounding: `documentLineAccounts`); and a role on a template liability (income tax payable) is
 * a posting rule's too. Nothing goes by an account's name, because a tenant can rename any of them.
 */
export function sellingAccounts(chart: readonly Account[] | undefined): Account[] {
  const offered = documentLineAccounts(chart);
  return [
    ...offered.filter((account) => account.group === "Income"),
    ...offered.filter((account) => account.group === "Liabilities" && !account.hasRole),
  ];
}
